import { observer } from 'mobx-react'
import { useCallback, useContext, useEffect } from 'react'
import { LoadingSpinner } from '@/components/Generic'
import { StoreContext } from '@store/Root.store'
import { axiosInstance } from '@/methods/axiosConfig'
import { API_URL, ONBOARDING_SERVICE_PATH } from '@/constants/apiUrl'
import { forceRedirect } from '@/methods/forceRedirect'
import { devLog } from '@/methods/devLog'
import { ErrorSantanderPage } from './ErrorSantanderPage'
import { FailureReasonTypes, FAILURE_REASONS } from '@/constants/verifiedTypes'

interface GenerateRedirectUrlResponse {
  redirectUrl: string
}

export const VerifiedSantanderPage = observer(() => {
  const store = useContext(StoreContext)

  const location = window.location.href
  const url = new URL(location)
  const isError = url.searchParams.get('error')
  const errorReason = url.searchParams.get('errorReason') as FailureReasonTypes

  const generateRedirectUrl = useCallback(async () => {
    if (!isError) {
      try {
        const { data } = await axiosInstance.get<GenerateRedirectUrlResponse>(
          `${API_URL}/${ONBOARDING_SERVICE_PATH}/get-redirect-url-on-complete`,
          {
            withCredentials: true,
          }
        )

        data?.redirectUrl && forceRedirect(data.redirectUrl)
      } catch (error) {
        devLog('Error generating url:', error)
      }
    }
  }, [isError])

  useEffect(() => {
    generateRedirectUrl()
  }, [])

  if (isError)
    return (
      <ErrorSantanderPage
        errorReason={errorReason && FAILURE_REASONS.includes(errorReason) ? errorReason : 'default'}
      />
    )

  return (
    <div className="page-container mobile-m-0 vertically-centered">
      <LoadingSpinner />
    </div>
  )
})
